import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  KaizenResultValidationService,
  type CreateKaizenResultValidationInput,
} from '../services/kaizenResultValidationService';

export const kaizenResultValidationKeys = {
  list: (kaizenId: string) => ['kaizen-result-validations', kaizenId] as const,
  snapshots: (kaizenId: string) => ['kaizen-result-snapshots', kaizenId] as const,
};

export function useKaizenResultValidations(kaizenId: string | null) {
  return useQuery({
    queryKey: kaizenResultValidationKeys.list(kaizenId ?? ''),
    enabled: Boolean(kaizenId),
    queryFn: () => KaizenResultValidationService.listByKaizen(kaizenId as string),
  });
}

export function useEligibleKaizenSnapshots(kaizenId: string | null) {
  return useQuery({
    queryKey: kaizenResultValidationKeys.snapshots(kaizenId ?? ''),
    enabled: Boolean(kaizenId),
    queryFn: async () => {
      const kaizen = await KaizenResultValidationService.loadKaizen(kaizenId as string);
      const snapshots = await KaizenResultValidationService.loadSnapshots(kaizenId as string);
      return { kaizen, snapshots };
    },
  });
}

export function useCreateKaizenResultValidation(kaizenId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: Omit<CreateKaizenResultValidationInput, 'kaizenId'>) =>
      KaizenResultValidationService.createValidation({ ...input, kaizenId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: kaizenResultValidationKeys.list(kaizenId) });
    },
  });
}
